import React, { useEffect, useState } from 'react';
import {
    DropdownMenuStateless,
    DropdownItemGroup,
    DropdownItem
} from '@atlaskit/dropdown-menu';

interface FilterProps {
    filterTitle: string;
    filterValues: any[];
    setFilterValues: any;
    allowFilterAll?: boolean;
    queryByString?: boolean;
    shouldReset?: boolean;
    setShouldReset?: any;
}

const FilterSelector = ({
    filterTitle,
    filterValues,
    setFilterValues,
    allowFilterAll = true,
    queryByString = false,
    shouldReset,
    setShouldReset
}: FilterProps) => {
    const [isOpen, setIsOpen] = useState(false);
    const [selected, setSelected] = useState(filterTitle);

    useEffect(() => {
        if (shouldReset) {
            setSelected(filterTitle);
            setShouldReset(false);
        }
    }, [shouldReset, filterTitle]);

    return (
        <DropdownMenuStateless
            trigger={selected}
            triggerType="button"
            isOpen={isOpen}
            onOpenChange={() => setIsOpen(!isOpen)}
        >
            <DropdownItemGroup title={filterTitle}>
                {allowFilterAll && (
                    <DropdownItem
                        key={`All-${filterTitle}s`}
                        onClick={() => {
                            setSelected(`All ${filterTitle}s`);
                            setFilterValues(filterValues);
                        }}
                    >
                        {`All ${filterTitle}s`}
                    </DropdownItem>
                )}
                {filterValues.map((item) => (
                    <DropdownItem
                        key={item}
                        onClick={() => {
                            setSelected(item);
                            setFilterValues(queryByString ? item : [item]);
                        }}
                    >
                        {item}
                    </DropdownItem>
                ))}
            </DropdownItemGroup>
        </DropdownMenuStateless>
    );
};

export default FilterSelector;
